{
  "fr": {
    "choice": {
      "actions": {
        "delete_choice": "Supprimer le choix",
        "delete_choice_list": "Supprimer la liste de choix"
      },
      "labels": {
        "not_selected": "Non sélectionné",
        "selected": "Sélectionné"
      },
      "messages": {
        "delete_choice": "Êtes-vous sûr de vouloir supprimer le choix {title}?",
        "delete_choice_list": "Êtes-vous sûr de vouloir supprimer la liste de choix {title}?"
      },
      "toasts": {
        "create": "Choix créé avec succès",
        "delete": "Choix supprimé avec succès",
        "update": "Choix mise à jour avec succès"
      }
    }
  }
}